export default "__VITE_ASSET__Dc7jIOXv__"